import * as React from "react";
import {isEmpty as _isEmpty} from "lodash"
import { IPatientConcern } from "@curefit/ehr-common";
import {ISymptom} from "@curefit/care-common";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";

/**
 * Created by aditya on 28/02/18.
 */

let ConcernEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "trouble", display: "TROUBLE", mandatory: true},
    {label: "lastOccurence", display: "LAST OCCURENCE"},
    {label: "frequency", display: "FREQUENCY"}
];


export interface PatientConcernEditorProps {
    updatedConcerns: {item: IPatientConcern}[];
    updateConcerns: (updatedConcerns: {item: IPatientConcern}[]) => void;
    fetchStaticSymptomData: (input: string) => Promise<any>;
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}

class PatientConcernEditor extends React.Component<PatientConcernEditorProps> {

    constructor(props: PatientConcernEditorProps) {
        super(props);
    }

    onConcernRemove = (index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedConcerns);
        currUpdatedSymptoms.splice(index, 1);
        this.props.updateConcerns(currUpdatedSymptoms);
    }

    onConcernChange = (updatedSymptom: ISymptom, index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedConcerns);
        currUpdatedSymptoms[index] = updatedSymptom;
        this.props.updateConcerns(currUpdatedSymptoms);
    }

    render() {
        let fetchStaticSymptomData = this.props.fetchStaticSymptomData;
        return (
            <div className="patient-concern-editor">
                {
                    !_isEmpty(this.props.questionnaire) &&
                        <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
                }
                <CustomHeader headerInfos={ConcernEditorHeaderInfos} rootCls={"patient-concern"}/>
                <TemplatedList templateName={"concern"} commonProps={{fetchStaticSymptomData}}
                               defaultItem={{item: ModelFactory.createNewConcern()}}
                               listItems={this.props.updatedConcerns}
                               onItemRemove={this.onConcernRemove}
                               onItemChange={this.onConcernChange}/>
            </div>
        );
    }
}

export default PatientConcernEditor